<script setup lang="ts">
interface Content {
  title?: string;
  description?: string[];
  descImage?: string
}

interface Props {
  content: Content
}

const props = withDefaults(defineProps<Props>(), {
  content: () => ({
    title: '业务介绍',
    description: [
      '我们致力于为客户提供高质量的产品和服务',
      '通过创新技术和专业团队，实现客户价值最大化',
      '持续改进，追求卓越，成为行业领先者'
    ],
    descImage: '/images/business-introduction.png'
  })
})
</script>

<template>
  <section class="page-business-introduction relative w-full flex flex-col items-center max-ml:py-2rem ">
    <PageTitle :title="props.content.title" />
    <div>
      <PageContentCenter class="flex justify-arounds max-ml:flex-col ">
        <!-- 左边插槽或内容 -->
        <div class="text-left w-50% self-center max-ml:w-100% max-ml:pt-1.5rem">
          <slot name="left">
            <p class="text-[#616671] text-[0.9rem] mb-[1.13rem] w-32.5rem leading-[1.5rem] max-ml:w-100%"
              v-for="desc in props.content.description">{{
                desc }}</p>
          </slot>
        </div>

        <!-- 右边插槽或内容 -->
        <slot name="right">
          <div class="w-50% max-ml:hidden">
            <Pic :src="props.content.descImage" class="w-[80rem]"></Pic>
          </div>
        </slot>
      </PageContentCenter>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.page-business-introduction {
  position: relative;
}
</style>